import React from 'react';
import { Route, withRouter } from 'react-router-dom';
import { auth0client } from './Auth';

function SecuredRoute(props: any) {
  const { component: Component, path } = props;

  if (props.location.search) {
    console.log('setting query string');
    localStorage.setItem('queryString', props.location.search);
  }

  localStorage.setItem('pathRequested', path);


  let isAuthenticated = auth0client.isAuthenticated();
  return (
    <Route path={path} render={() => {
      if (!(isAuthenticated)) {
        auth0client.login();
        return <div></div>;
      }
      return <Component />
    }} />
  );
}

export default withRouter(SecuredRoute);